import { useCallback } from 'react';

import { getAtlasURL } from '@atlassian/conversation-assistant-agent/utils/getAtlasURL';

import { useGlobalConfig } from '../../../utils/global-config/useGlobalConfig';

export const useAtlasURL = (): {
	atlasURL: (path: string) => string;
} => {
	const { siteId, orgId } = useGlobalConfig();

	const atlasURL = useCallback(
		(path: string): string => getAtlasURL(siteId, path, orgId),
		[orgId, siteId],
	);

	return {
		atlasURL,
	};
};
